<vi-card data-at-dialog [dialog]="true">
  <div title class="flex flex-row justify-between items-stretch">
    <h2 data-at-title>
      {{ title | translate }}
    </h2>
    <mat-icon (click)="onCancelSelectingDate()" class="close-icon">close</mat-icon>
  </div>
  <div body data-at-body class="content-body flex flex-col gap-[24px]">
    <vi-text data-at-description color="primary" size="medium" class="content">
      <div content class="content">
        {{ description | translate }}
      </div>
    </vi-text>

    <div class="content-wrapper">
      <app-device-time-warning *ngIf="deviceTimeWithOffset"></app-device-time-warning>

      <mat-form-field class="date-range-form" appearance="fill">
        <mat-label>{{
          '+INSTALLATIONS.INSTALLATION.HOLIDAY_MODE.DIALOG.START_END_RANGE_LABEL' | translate
        }}</mat-label>
        <mat-date-range-input
          [min]="minStartDate"
          [formGroup]="dateRange"
          [rangePicker]="dateRangePicker"
        >
          <input
            matStartDate
            formControlName="start"
            readonly
            gtm="onTextField"
            gtmId="start-date"
            gtmAction="Start date"
            gtmCategory="Holiday program"
            [gtmOn]="['focus', 'blur']"
            data-at-start-date
            matInput
            placeholder="{{
              minDaysDifference
                ? ('+INSTALLATIONS.INSTALLATION.HOLIDAY_MODE.DIALOG.DEPARTURE_DATE' | translate)
                : ('+INSTALLATIONS.INSTALLATION.HOLIDAY_MODE.DIALOG.START_DATE' | translate)
            }}"
            fieldTextContentTooltip
          />
          <input
            matEndDate
            formControlName="end"
            readonly
            matInput
            gtm="onTextField"
            gtmId="end-date"
            gtmAction="End date"
            gtmCategory="Holiday program"
            [gtmOn]="['focus', 'blur']"
            data-at-end-date
            [errorStateMatcher]="errorStateMatcher"
            placeholder="{{
              minDaysDifference
                ? ('+INSTALLATIONS.INSTALLATION.HOLIDAY_MODE.DIALOG.RETURN_DATE' | translate)
                : ('+INSTALLATIONS.INSTALLATION.HOLIDAY_MODE.DIALOG.END_DATE' | translate)
            }}"
            fieldTextContentTooltip
          />
        </mat-date-range-input>

        <mat-datepicker-toggle matSuffix [for]="dateRangePicker">
          <mat-icon matDatepickerToggleIcon>calendar_today</mat-icon>
        </mat-datepicker-toggle>

        <mat-date-range-picker #dateRangePicker></mat-date-range-picker>
        <mat-error *ngIf="endDateFormControl.hasError('sameDateNotAllowed')">
          {{
            '+INSTALLATIONS.INSTALLATION.HOLIDAY_MODE.DIALOG.ERROR.SAMEDAY_NOT_ALLOWED' | translate
          }}
        </mat-error>
        <mat-error
          *ngIf="
            startDateFormControl.hasError('required') || endDateFormControl.hasError('required')
          "
        >
          {{ '+INSTALLATIONS.INSTALLATION.HOLIDAY_MODE.DIALOG.ERROR.REQUIRED' | translate }}
        </mat-error>
        <mat-error *ngIf="startDateFormControl.hasError('matDatepickerMin')">
          {{ '+INSTALLATIONS.INSTALLATION.HOLIDAY_MODE.DIALOG.ERROR.DATE_MIN' | translate }}
        </mat-error>
        <mat-error
          *ngIf="
            endDateFormControl.hasError('minEndDate') ||
            endDateFormControl.hasError('matDatepickerMin')
          "
        >
          {{
            '+INSTALLATIONS.INSTALLATION.HOLIDAY_MODE.DIALOG.ERROR.MIN_DATES_DIFFERENCE'
              | translate
                : {
                    difference: minDaysDifference
                  }
          }}
        </mat-error>
      </mat-form-field>
    </div>

    <div
      *ngIf="isMultiFamily"
      data-at-circuits-dropdown-container
      class="flex flex-col justify-start items-start flex-1"
    >
      <div class="circuits-label">
        {{ '+INSTALLATIONS.INSTALLATION.HOLIDAY_MODE.SELECT_HEATING_CIRCUIT' | translate }}:
      </div>
      <ng-container
        *ngIf="
          circuits$
            | async
            | ready
            | featureValue: 'enabled'
            | viToDropdownModel: 'circuits':heatingCircuitTranslation as dropdownCircuits
        "
      >
        <vi-dropdown
          class="circuits-dropdown flex-[20%] max-w-[100%] lt-md:flex-[30%] lt-md:max-w-[30%] lt-sm:flex-[100%] lt-sm:max-w-[100%]"
          data-at-circuits-dropdown
          [options]="dropdownCircuits"
          [option]="this.selectedCircuit"
          (optionChange)="onCircuitChange($event)"
        >
        </vi-dropdown>
      </ng-container>
    </div>
  </div>
  <div
    footer
    data-at-footer
    class="flex flex-row xs:flex-col-reverse gap-[8px] justify-between items-stretch flex-auto"
  >
    <button
      data-at-cancel-btn
      mat-button
      color="primary"
      gtm="onActivateHolidayProgramNo"
      (click)="onCancelSelectingDate()"
    >
      {{ 'GENERAL.BUTTON.CANCEL' | translate }}
    </button>
    <button
      data-at-change-btn
      mat-raised-button
      color="primary"
      gtm="onActivateHolidayProgramYes"
      [disabled]="!isFormValid()"
      (click)="onSubmit()"
    >
      {{ 'GENERAL.BUTTON.ACTIVATE' | translate }}
    </button>
  </div>
</vi-card>
